import { useState, useEffect, useContext } from 'react'
import axios from 'axios';
import Select from 'react-select';
import ContextStates from '../../context/ContextStates';
import { FaEye, FaPen, FaTrash } from 'react-icons/fa'
import { MdAttachMoney } from "react-icons/md";
import { Url } from '../Url';

import marker from "leaflet/src/images/marker.svg"
import marker2 from '../../assets/markers/marker2.svg'
import marker3 from "../../assets/markers/marker3.svg"
import marker4 from "../../assets/markers/marker4.svg"

import L, { Icon } from "leaflet";
import { MapContainer, TileLayer, Popup, Marker, useMap } from 'react-leaflet'
import "leaflet/dist/leaflet.css"

const myIcon = new Icon({ iconUrl: marker, iconSize: [32, 32] });
const myIcon2 = new Icon({ iconUrl: marker2, iconSize: [32, 32] });
const myIcon3 = new Icon({ iconUrl: marker3, iconSize: [32, 32] });
const myIcon4 = new Icon({ iconUrl: marker4, iconSize: [32, 32] });

function getIconByMarkerCode(code) {
    // ajustá si tu mapeo difiere
    if (code === 0) return myIcon3; // sin visita
    if (code === 1) return myIcon;  // pedido
    if (code === 2) return myIcon4; // entregado (u otro)
    return myIcon2;                  // rechazó / default
}

// Recentrar cuando cambia "position"
function RecenterOnPosition({ position, zoom = 16, animate = true }) {
    const map = useMap();
    useEffect(() => {
        if (!position) return;
        map.setView(position, zoom, { animate });
    }, [map, position, zoom, animate]);
    return null;
}

// Ajustar a todos los clientes (fitBounds)
function FitBoundsToClientes({ clientes, padding = 0.2 }) {
    const map = useMap();
    useEffect(() => {
        if (!clientes || !clientes.length) return;

        const coords = clientes
            .filter(c => c.latitud && c.longitud)
            .map(c => [parseFloat(c.latitud), parseFloat(c.longitud)]);

        if (!coords.length) return;

        if (coords.length === 1) {
            map.setView(coords[0], 16, { animate: true });
        } else {
            const bounds = L.latLngBounds(coords);
            map.fitBounds(bounds.pad(padding), { animate: true });
        }
    }, [map, clientes, padding]);

    return null;
}

const ListadoClientes = () => {
    const [map, setMap] = useState(null);
    const [tab, setTab] = useState(0);
    const [filtro, setFiltro] = useState(false);
    const [deudores, setDeudores] = useState(false);
    const [position, setPosition] = useState([-26.833018562210178, -65.20875863504794]);

    const {
        clientes, setClientes,
        buscarCliente, roles, modify,
        setFormView, setViewOpen, setClienteSelected,
        idUsuario, zonas, setZonas, zona, setZona
    } = useContext(ContextStates);

    // Zonas
    useEffect(() => {
        const consultaZonas = async () => {
            const formData = new FormData();
            formData.append("id", 1);
            formData.append("activo", 1);
            try {
                const response = await axios.post(Url + 'api/listZonas.php', formData);
                setZonas(response.data.results);
            } catch (e) {
                console.log(e);
            }
        };
        consultaZonas();
    }, [setZonas]);

    // Clientes
    useEffect(() => {
        const consultaClientes = async () => {
            let filt = filtro ? 1 : 0;
            let deudas = deudores ? 1 : 0;
            const formData = new FormData();
            formData.append('idusuario', idUsuario);
            formData.append('filtro', filt);
            formData.append('deudas', deudas);
            formData.append('busqueda', buscarCliente || '');
            formData.append('zona', zona?.id || 0);

            try {
                const response = await axios.post(Url + 'api/listClientes.php', formData);
                const arr = Array.isArray(response?.data?.results) ? response.data.results : [];
                setClientes(arr);

                // opcional: setear posición al primero (además de fitBounds)
                if (arr.length > 0) {
                    const lat = parseFloat(arr[0].latitud);
                    const lon = parseFloat(arr[0].longitud);
                    if (Number.isFinite(lat) && Number.isFinite(lon)) {
                        setPosition([lat, lon]);
                    }
                }
            } catch (e) {
                console.log(e);
            }
        };
        consultaClientes();
    }, [modify, filtro, buscarCliente, deudores, zona, idUsuario, setClientes]);

    const asignarCliente = (id) => {
        const c = clientes?.find(el => el.id === id);
        if (c) setClienteSelected(c);
    };

    const pagoCliente = async (id) => {
        asignarCliente(id);
        setFormView(34);
        setViewOpen(true);
    };

    const verCliente = async (id) => {
        asignarCliente(id);
        setFormView(33);
        setViewOpen(true);
    };

    const editarCliente = async (id) => {
        asignarCliente(id);
        setFormView(31);
        setViewOpen(true);
    };

    const eliminarCliente = async (id) => {
        asignarCliente(id);
        setFormView(32);
        setViewOpen(true);
    };

    return (
        <div>
            <div className='bg-blue-100 rounded-md p-3 mb-5'>
                <div className="w-full md:w-1/2 mx-auto mb-4">
                    <Select
                        options={zonas}
                        placeholder="Seleccione la zona"
                        onChange={(value) => setZona(value)}
                        name='sZona'
                    />
                </div>
                <label className="w-full md:w-1/2 mx-auto block my-5 text-black uppercase font-bold">
                    <input
                        className='mr-1'
                        type='checkbox'
                        onChange={() => setDeudores(!deudores)}
                        checked={deudores}
                    />
                    Clientes con deudas
                </label>
            </div>

            <div className='flex p-5'>
                <button
                    className={`ml-3 p-3 rounded-lg ${tab === 0 ? 'bg-blue-800 text-white shadow-md' : 'border border-blue-400 text-blue-400'}`}
                    onClick={() => setTab(0)}
                >
                    Ver en Listado
                </button>
                <button
                    className={`ml-3 p-3 rounded-lg ${tab === 1 ? 'bg-blue-800 text-white shadow-md' : 'border border-blue-400 text-blue-400'}`}
                    onClick={() => setTab(1)}
                >
                    Ver en Mapa
                </button>
            </div>

            {tab === 0 ? (
                <table className='table-auto w-full border-collapse border-spacing-5 border-slate-400 text-gray-700 rounded-xl mx-auto'>
                    <thead>
                        <tr className='uppercase bg-blue-400 text-white'>
                            <th className='border-gray-400 p-2'>#</th>
                            <th className='border-gray-400 p-2'>Apellido</th>
                            <th className='border-gray-400 p-2'>Nombre</th>
                            <th className='border-gray-400 p-2'>Domicilio</th>
                            <th className='border-gray-400 p-2'>Tel.</th>
                            <th className='border-gray-400 p-2'>Saldo</th>
                            <th className='border-gray-400 p-2'>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {clientes?.map((item, index) => (
                            <tr
                                key={item.id}
                                className={`hover:bg-slate-200 border-b border-gray-200 ${index % 2 === 0 ? 'bg-white' : 'bg-slate-100'}`}
                            >
                                <td className='border-gray-400 p-1 text-center font-bold'>{index + 1}</td>
                                <td className='border-gray-400 p-1 text-center'>{item.apellido}</td>
                                <td className='border-gray-400 p-1 text-center'>{item.nombre}</td>
                                <td className='border-gray-400 p-1 text-center'>{item.domicilio}</td>
                                <td className='border-gray-400 p-1 text-center'>{item.telefono}</td>
                                <td className={`border-gray-400 p-1 text-center ${item.dias >= 7 && item.saldo > 0 ? 'bg-red-500 text-white' : item.saldo > 0 && 'bg-yellow-400 text-gray-800'}`}>$ {item.saldo ? item.saldo.toLocaleString("es-AR", { maximumFractionDigits: 2 }) : 0}</td>
                                <td className='p-1 flex justify-center'>
                                    <button className='bg-orange-500 p-3 rounded-md text-white' onClick={() => pagoCliente(item.id)}>
                                        <MdAttachMoney />
                                    </button>
                                    <button className='bg-indigo-500 p-3 rounded-md text-white ml-3' onClick={() => verCliente(item.id)}>
                                        <FaEye />
                                    </button>
                                    {(roles.includes("1")) && (
                                        <>
                                            <button className='bg-gray-400 p-3 rounded-md text-white ml-3' onClick={() => editarCliente(item.id)}>
                                                <FaPen />
                                            </button>
                                            <button className='bg-red-500 p-3 rounded-md text-white ml-3' onClick={() => eliminarCliente(item.id)}>
                                                <FaTrash />
                                            </button>
                                        </>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <MapContainer
                    center={position}
                    zoom={18}
                    scrollWheelZoom
                    className="mx-auto h-full z-0"
                    whenCreated={(m) => setMap(m)}
                    style={{ maxWidth: '80vw', height: 800 }}
                >
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />

                    {/* Ajuste automático a todos los clientes */}
                    <FitBoundsToClientes clientes={clientes} />

                    {/* Recentrar al seleccionar un punto (opcional) */}
                    <RecenterOnPosition position={position} />

                    {clientes?.map((item, index) => {
                        const lat = parseFloat(item.latitud);
                        const lon = parseFloat(item.longitud);
                        if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;

                        return (
                            <Marker
                                key={index}
                                position={[lat, lon]}
                                icon={getIconByMarkerCode(item.marker)}
                                eventHandlers={{
                                    click: () => setPosition([lat, lon]),
                                }}
                            >
                                <Popup>
                                    <strong>Nombre:</strong> {`${item.apellido}, ${item.nombre}`}<br />
                                    <strong>Domicilio:</strong> {item.domicilio}<br />
                                    <strong>Teléfono:</strong> {item.telefono}
                                </Popup>
                            </Marker>
                        );
                    })}
                </MapContainer>
            )}
        </div>
    );
}

export default ListadoClientes
